import { observer } from 'mobx-react';
import { IValidationGroup } from '../../../../../../../hooks/validation-group/validation-group-hook';
import ApiKeyField from '../fields/api-key-field/api-key-field';
import ApiSecretField from '../fields/api-secret-field/api-secret-field';
import CustomerNumberField from '../fields/customer-number-field/customer-number-field';
import CustomerNumberCredentialsStore from '../../../../stores/credentials/shipping/customer-number-credentials-store';

interface IProps {
    credentialsStore: CustomerNumberCredentialsStore,
    vGroup: IValidationGroup,
    apiKeyLabel?: string,
    apiKeyNote?: string,
    apiSecretLabel?: string,
    apiSecretNote?: string,
    customerNumberLabel?: string,
    customerNumberNote?: string,
}

const CustomerNumberCredentials: React.FC<IProps> = observer(({ 
    credentialsStore, 
    vGroup, 
    apiKeyLabel, 
    apiKeyNote,
    apiSecretLabel,
    apiSecretNote,
    customerNumberLabel,
    customerNumberNote
}) => {
    return (
        <>
            <ApiKeyField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label={apiKeyLabel}
                note={apiKeyNote}
            />
            <ApiSecretField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label={apiSecretLabel}
                note={apiSecretNote}
            />
            <CustomerNumberField
                credentialsStore={credentialsStore}
                validationGroup={vGroup}
                label={customerNumberLabel}
                note={customerNumberNote}
            />
        </>
    );
});

export default CustomerNumberCredentials;
